import { useTranslation } from 'react-i18next';
import { AlarmClock, Pin } from 'lucide-react';
import { useUi } from '../state/ui';
import { useMemos } from './data';
import { todayIso } from '../components/tasks/format';

/** Dashboard block: upcoming reminders and pinned items from Onthouden. */
export function MemosBlock() {
  const { t, i18n } = useTranslation();
  const memos = useMemos();
  const open = useUi((s) => s.open);
  if (!memos) return null;
  const today = todayIso();
  const upcoming = memos
    .filter((m) => m.remindAt && m.remindAt.slice(0, 10) >= today)
    .sort((a, b) => a.remindAt!.localeCompare(b.remindAt!));
  const pinned = memos.filter((m) => m.pinned && !upcoming.includes(m));
  // Then the rest, newest first: everything you keep shows up here.
  const rest = memos
    .filter((m) => !upcoming.includes(m) && !pinned.includes(m))
    .sort((a, b) => b.updatedAt - a.updatedAt);
  const items = [...upcoming, ...pinned, ...rest].slice(0, 8);
  return (
    <div>
      {items.length === 0 ? (
        <p className="text-sm text-fg-muted">{t('memos.empty')}</p>
      ) : (
        <ul className="flex flex-col gap-1">
          {items.map((m) => (
            <li key={m.id} className="flex items-center gap-2 text-sm">
              {m.remindAt ? (
                <AlarmClock className="size-3.5 shrink-0 text-fg-muted" />
              ) : m.pinned ? (
                <Pin className="size-3.5 shrink-0 text-fg-muted" />
              ) : (
                <span aria-hidden className="size-3.5 shrink-0 text-center text-fg-muted">
                  •
                </span>
              )}
              <button
                type="button"
                onClick={() => open({ kind: 'page', pageId: m.id })}
                className="min-w-0 flex-1 truncate text-left hover:underline"
              >
                {m.title || t('page.untitled')}
              </button>
              {m.remindAt && (
                <span className="shrink-0 text-xs text-fg-muted">
                  {new Date(m.remindAt).toLocaleString(i18n.language, {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
      <button
        type="button"
        onClick={() => open({ kind: 'memos' })}
        className="mt-2 text-xs text-fg-muted hover:text-fg"
      >
        {t('memos.title')} →
      </button>
    </div>
  );
}
